/* eslint-disable @typescript-eslint/no-explicit-any */
import { TableDataWithImage } from '@spo/logic';
import { Table } from '@tanstack/react-table';
import { TableRow } from '../tableRow';
import './tableBody.scss';

export interface TableBodyProps {
  table: Table<TableDataWithImage>;
  onCellClick?: (smId: string, startDate: string, endDate: string) => void;
  selectedSmIds: string[];
  selectSmId: (smId: string) => void;
}

export const TableBody = ({
  table,
  onCellClick,
  selectedSmIds,
  selectSmId,
  ...props
}: TableBodyProps) => {
  return (
    <tbody {...props} className="super-model_table-body">
      {table.getRowModel().rows.map((row, rowIndex: number) => {
        return (
          <TableRow
            key={row.original.id}
            rowIndex={rowIndex}
            row={row}
            isRowSelected={row.getIsSelected()}
            selectedSmIds={selectedSmIds}
            selectSmId={selectSmId}
            onCellClick={onCellClick}
          />
        );
      })}
    </tbody>
  );
};
